<template>
  <div
    class="fixed bottom-0 left-0 right-0 top-0 z-[100] flex flex-col items-center justify-center bg-background bg-opacity-70"
  >
    <p class="text-main text-2xl">{{ text }}</p>
    <div class="mt-10 h-2 w-1/3 rounded-full bg-blue-400">
      <div
        :style="`width: ${progress}%`"
        class="h-full rounded-full bg-primary text-center text-xs text-white"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressLoader",
  props: {
    text: {
      type: String,
      default: "Generowanie wyników...",
    },
  },
  data() {
    return {
      progress: 0,
      progressInterval: null,
    };
  },
  methods: {
    startProgress() {
      this.progress = 0;
      this.progressInterval = setInterval(() => {
        this.progress += 5;
        if (this.progress >= 100) {
          clearInterval(this.progressInterval);
          this.startProgress();
        }
      }, 1000);
    },
  },
  mounted() {
    this.startProgress();
  },
  unmounted() {
    clearInterval(this.progressInterval);
  },
};
</script>
